import { ITsLePhiBuocNhaySaveRequest } from "../../../model/request/category/tsLePhiBuocNhaySaveRequest";
import { ITsLePhiBuocNhay } from "../../../model/respone/category/ITsLePhiBuocNhay";
import { IHeNganhTheoDotTuyenSinh } from "../../reducer-model/category/IDmLoaiThuTuyenSinhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTsLePhiBuocNhayActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  CHANGE_DOT: 0,
  CHANGE_MODE: 0,

  LOAD_START: 0,
  LOAD_SUCCESS: [] as ITsLePhiBuocNhay[],
  LOAD_ERROR: "",

  LOAD_HE_NGANH_START: 0,
  LOAD_HE_NGANH_SUCCESS: [] as IHeNganhTheoDotTuyenSinh[],
  LOAD_HE_NGANH_ERROR: "",

  SAVE_START: {} as ITsLePhiBuocNhaySaveRequest,
  SAVE_SUCCESS: {} as {
    id_he: number;
    id_nganh: number;
    items: ITsLePhiBuocNhay[];
  },
  SAVE_ERROR: "",
};
export const eTsLePhiBuocNhayActionIds = generateActionTypeIds(
  eTsLePhiBuocNhayActionsObj,
  "LE_PHI_BUOC_NHAY"
);
export type ITsLePhiBuocNhayActionTypes = IGenericActionType<
  typeof eTsLePhiBuocNhayActionsObj,
  "LE_PHI_BUOC_NHAY"
>;
